import { Theme, makeStyles } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

import type { NarrowBoxProps } from './NarrowBox';

type StyleProps = { width: Breakpoint };

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  root: ({ width }) => ({
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    [theme.breakpoints.up(width)]: {
      width: theme.breakpoints.values[width],
    },
  }),
}));

/** @deprecated Legacy MUI copy — migrate consumers to the Encore NarrowBox and delete. */
export const NarrowBoxMui = ({ width = 'md', ...props }: NarrowBoxProps) => {
  const classes = useStyles({ width });
  return <div className={classes.root} {...props} />;
};
